import PartialPaymentHotelBannerView from '@/js/common/components/partialPayment/partialPaymentHotelBanner/PartialPaymentHotelBanner';
import PartialPaymentBannerDgView from '@/js/desktop/components/partialPayment/partialPaymentBannerDg/PartialPaymentBannerDg';

import './assets/styles.scss';

export default class PartialPaymentHotelBannerDesktopView extends PartialPaymentHotelBannerView {
    initDOMEvents() {
        $(document)
            .on('click', '.js-open-partial-payment-info', (e) => {
                e.preventDefault();

                this.partialPaymentBannerDg = new PartialPaymentBannerDgView({
                    countryName: this.viewModel.get('countryName'),
                    tourProducts: this.viewModel.get('tourProducts'),
                });

                this.partialPaymentBannerDg?.dialog?.show?.();
            });
    }
}
